import Tooltip from 'legacy/components/generic/Tooltip';
import SVGInline from 'react-svg-inline';

import {
  AVM_KEY_HC,
  CONFIDENCE_LEVEL_HIGH,
  CONFIDENCE_LEVEL_MED
} from 'legacy/appstore/constants';

import { capitalizeFirstLetter } from 'legacy/utils/strings';

import { ValueConfidence as theme } from 'legacy/css-modules';

import highConfidenceBadge from 'legacy/assets/svg-inline/high_confidence_badge.svg';

const ValueConfidence = ({ confidenceLevel, tooltipText, selectedAvmKey }) => {
  const showBadge =
    confidenceLevel === CONFIDENCE_LEVEL_HIGH && selectedAvmKey === AVM_KEY_HC;
  const ConfidenceAnchor = showBadge ? (
    <SVGInline
      style={{ height: '55px', width: '55px' }}
      data-hc-name="valuation-confidence-icon"
      svg={highConfidenceBadge}
    />
  ) : undefined;
  return (
    <Tooltip
      theme={{
        Component: showBadge ? theme.BadgePosition : theme.IconPosition
      }}
      trigger={ConfidenceAnchor}
      content={
        <div>
          {confidenceLevel && (
            <div className={theme.TooltipLabel}>{`${
              confidenceLevel === CONFIDENCE_LEVEL_MED
                ? 'Medium'
                : capitalizeFirstLetter(confidenceLevel)
            } Confidence`}</div>
          )}
          <div className={theme.TooltipDescription}>{tooltipText}</div>
        </div>
      }
    />
  );
};

export default ValueConfidence;
